import React from "react";
import ProductImage from "@src/components/widgets/ProductImage";
import { OrderedDistributorProduct } from "@src/types/product";
import { Link } from "react-router-dom";
import PriceDisplay from "@src/components/common/PriceDisplay/PriceDisplay";
import { getProductVariantSubheading } from "@src/utils/product";

interface OrderDetailTileProps {
  distributorProduct: OrderedDistributorProduct;
}

export default function OrderedDistributorProductDetails({
  distributorProduct,
}: OrderDetailTileProps) {
  const { product, imageUrl, thumbnailUrl } = distributorProduct;
  const imageSrc = thumbnailUrl ?? imageUrl ?? product.thumbnailUrl;
  const variantSubheading = getProductVariantSubheading(product);

  const wrapJsxInLink = (jsx: React.JSX.Element, location: string) => (
    <Link
      key={`${location}-product-link-${product!.id}`}
      className="link text-default width-fit-content"
      to={`/product/${product!.id}/`}
    >
      {jsx}
    </Link>
  );

  return (
    <div className="flex-row spaced-content-sm">
      {wrapJsxInLink(
        <ProductImage imageSrc={imageSrc} sizePx={100} />,
        "image",
      )}
      <div className="flex-1 flex-column flex-center spaced-content-v-xs">
        <div className="width-100 flex-row space-between font-weight-bold text-lg">
          {wrapJsxInLink(<span>{product.itemName}</span>, "item-name")}
          <span>
            <PriceDisplay amount={distributorProduct.price} />
          </span>
        </div>
        {!!variantSubheading && (
          <div className="width-100 text-sm text-light">
            {variantSubheading}
          </div>
        )}
        <div className="width-100 text-sm">
          Qty: {distributorProduct.quantity}
        </div>
      </div>
    </div>
  );
}
